/**
 * A filter's selection is typed `string[] | number[]` whichever way it serializes, and a union of
 * arrays can't be pushed to. These guards tell which one a selection holds; an empty selection is
 * either, which is what lets it take its first value.
 */
export function is_number_list(values: readonly unknown[]): values is number[] {
    return values.every((value) => typeof value === 'number')
}

export function is_string_list(values: readonly unknown[]): values is string[] {
    return values.every((value) => typeof value === 'string')
}
